
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import eventosModule from '@/store/eventos'
import authModule from '@/store/auth'
import errorsModule from '@/store/errors'
import encuestasModule from '@/store/encuestas'
import dominiosModule from '@/store/dominios'
import documentacionModule from '@/store/documentacion'
import guiaOrientacionModule from '@/store/guia-orientacion'
import stylesModule from '@/store/styles'
import infoPopupModule from '@/store/popup-info'
import practicaOnline from '@/store/practica-online'
import notificaciones from '@/store/notificaciones'
import comunicaciones from '@/store/comunicaciones'
import filtros from '@/store/filtros'
import programas from '@/store/programas-practicas'
import CVModule from '@/store/cv'
import accionesAlumnoModule from '@/store/accionesAlumno'
import accionesEmpresaModule from '@/store/accionesEmpresa'
import VeeValidate, { Validator } from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';
import messages from '@/translations';
import { langdetector } from '@/langdetector';
import appinfo from '../../package.json';

//SET IDIOMA
localStorage.setItem('language', langdetector());
import * as Sentry from '@sentry/browser';
Sentry.setTag("dotia_version", appinfo.version);

let domain = 'https://administraciondotia.unileon.es';
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname.includes('dev.doubledot.es')){
  domain = 'https://sandbox-leon.dotia.es';
}
// if (window.location.hostname === "localhost"){
//   domain = 'https://localhost:44379';
// }


export const store = new Vuex.Store({
  state: {
    language: localStorage.getItem('language'),
    server: domain,
    loading: false,
    darkSide: window.localStorage.getItem('darkmode') || "false",
    packageVersion: appinfo.version
  },
  actions: {
    changeLanguage: ({ commit }, actualLang) => {
      return new Promise((resolve, reject) => {
        let nextLang = (actualLang == "es") ? "en" : "es";
        commit('setLanguage', nextLang);
        switch (nextLang) {
          case "es":
            Validator.localize('es', validatorEs);
            break;
          case "en":
            Validator.localize('en', validatorEn);
            break;
        }
        resolve(nextLang);
      });
    },
    setLoading: ({ commit }, value) => {
      commit('setLoading', value);
    },
    toggleDarkSide: ({ commit }) => {
      commit('setToggleDarkSide');
    },

  },
  getters: {
    getLanguage: state => state.language,
    getServer: state => state.server,
    getLoading: state => state.loading,
    getDarkSide: state => JSON.parse(state.darkSide),
    getTexts: state => {
      return messages[state.language];
    },
    getVersion: state => state.packageVersion,
  },
  mutations: {
    setLanguage(state, lang) {
      state.language = lang;
      localStorage.setItem('language', lang);
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setToggleDarkSide(state) {
      state.darkSide = !state.darkSide;
      window.localStorage.setItem("darkmode", state.darkSide);
      if(state.darkSide){
        document.getElementsByTagName("body")[0].classList.add("dark");
      }else{
        document.getElementsByTagName("body")[0].classList.remove("dark");
      }
    },
  },
  modules: {
    eventosModule,
    authModule,
    errorsModule,
    encuestasModule,
    dominiosModule,
    documentacionModule,
    guiaOrientacionModule,
    CVModule,
    accionesAlumnoModule,
    accionesEmpresaModule,
    stylesModule,
    infoPopupModule,
    practicaOnline,
    notificaciones,
    comunicaciones,
    filtros,
    programas
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js